import { OrderResponse } from '../../fetch/types';
import isOutsideReturnWindow from './isOutsideReturnWindow';
import isReturnExpired from './isReturnExpired';

export default function shouldRejectOutsideWindow(response: OrderResponse) {
  const rejectExpiredReturns =
    response?.merchant?.returns_configuration?.settings?.reject_expired_returns;
  if (!rejectExpiredReturns) return false;

  const expiresAt = response?.expires_at;
  if (expiresAt) return isReturnExpired(expiresAt);

  const returnWindowInDays =
    response?.merchant.returns_configuration.settings.return_window_days;
  const purchasedAt = response?.purchased_at;
  if (
    returnWindowInDays &&
    purchasedAt &&
    isOutsideReturnWindow(purchasedAt, returnWindowInDays)
  )
    return true;

  return false;
}
